import { render, staticRenderFns } from "./AuthenLayout.vue?vue&type=template&id=524657e1&scoped=true&"
import script from "./AuthenLayout.vue?vue&type=script&lang=js&"
export * from "./AuthenLayout.vue?vue&type=script&lang=js&"
import style0 from "./AuthenLayout.vue?vue&type=style&index=0&id=524657e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524657e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524657e1')) {
      api.createRecord('524657e1', component.options)
    } else {
      api.reload('524657e1', component.options)
    }
    module.hot.accept("./AuthenLayout.vue?vue&type=template&id=524657e1&scoped=true&", function () {
      api.rerender('524657e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/layout/AuthenLayout.vue"
export default component.exports